// extracted by mini-css-extract-plugin
export var collapsedSummary = "_n5-0";